import { cx } from "class-variance-authority";

export default function VerticalCardList({ children, className }) {
  return (
    <div
      className={cx(
        `
        flex flex-row
        flex-wrap    
        gap-x-3
        gap-y-4
        min-[404px]:gap-y-8
        w-full
        min-[404px]:max-w-[380px]
        min-[604px]:max-w-[580px]
        min-[820px]:max-w-[780px]
        min-[1020px]:max-w-[980px]
        min-[1220px]:max-w-[1180px]
        min-[1280px]:max-w-none
        min-[1280px]:gap-8        
        `,
        className
      )}
    >
      {children}
    </div>
  );
}
